const organizationParamsActions = {
  ORGANIZATION_PARAMS_INIT: 'ORGANIZATION_PARAMS_INIT',
  ORGANIZATION_PARAMS_SET: 'ORGANIZATION_PARAMS_SET',
  ORGANIZATION_PARAMS_ADD: 'ORGANIZATION_PARAMS_ADD',
  ORGANIZATION_PARAMS_DELETE: 'ORGANIZATION_PARAMS_DELETE',
  ORGANIZATION_PARAMS_UPDATE: 'ORGANIZATION_PARAMS_UPDATE'
};
export default organizationParamsActions;
